import React, {useState,useEffect} from "react"
import RegistrationInput from "./RegistrationInput"
import LoadingVisual from "./LoadingVisual"

function RegistrationKey(props) {
    const [loading, setLoading] = useState(false)
    const [userInput, setUserInput] = useState("")
    const [userData, setUserData] = useState("")
    const [authorised, setAuthorised] = useState(false)
    const [error, setError] = useState(false)
    
    function handleChange(event) {
        const {value} = event.target
        setUserInput(value)
    }
    
    function handleClick(event) {
        event.preventDefault()
        checkKey(userInput)
                
    }
        
    function checkKey(productKey) {
        setLoading(true)
        const productDetails = {
            product_id: 1,
            product_key: productKey,
            api_url: "purchase/auth"
        }

        contactDatabase(productDetails)
            .then((response) => {
                console.log('API response', response)
                setUserData(response.data)
                setAuthorised(response.success)
                setLoading(false)
                
                if (!response.success) {
                    setError(true)
                    setUserInput("")
                }
            }).catch((error) => {
                alert("Something went wrong. Please try again.")
                setLoading(false)
                setUserInput("")
            })
        
        
        function contactDatabase(data) {
          return fetch('/.netlify/functions/hello', {
            body: JSON.stringify(data),
            method: 'POST'
          }).then(response => {
            return response.json()
          })
        }
    }
    
    function goToPurchase() {
        window.open("https://paradoxparlours.com/escape-rooms/online", "_blank")
    }
    
    function goToContact() {
        window.open("https://paradoxparlours.com/contact", "_blank")
    }
    
    useEffect(() => {
        const storedKey = localStorage.getItem("localKey")
        if (storedKey) {
            setUserInput(storedKey)
            checkKey(storedKey)
        }
    },[])
    
    useEffect(() => {
        if (authorised) {
            props.callBackLogIn(true, userData, userInput)
        } else {
            props.callBackLogIn(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[authorised])
    
    return (
        <main>
            <div id="registration">
                <h2>The Case Of</h2> 
                <h1>The Disappearing Diamond</h1>
                <div className="colourStripe redTab centerBreak"></div>
                {loading ? <LoadingVisual /> : <RegistrationInput handleChange={handleChange} handleClick={handleClick} value={userInput} error={error}/> }
        
                <div className="colourStripe redTab centerBreak"></div>
            
                <div id="purchaseAKey">
                    <h2><em>Don't have a product key? Having trouble?</em></h2>
                    <div id="registrationOtherOptions">
                        <button className="standardButton" onClick={goToPurchase}>Purchase A Game</button>
                        <button className="standardButton" onClick={goToContact}>Contact Us</button>
                    </div>
                </div>
            </div>
            <div id="mainCornerCut"></div>
        </main>
    )
}

export default RegistrationKey